import { TableColumn } from "../table/TableColumn";

const DeviceInputColumns  : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "setting.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        sortByName: "setting.settingType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
    },
    {
        heading: "Used By",
        accessor: "usedBy",
        isNumeric: false,
        id: 2,
        // sortByName: "setting.sDist",
        // sortDirection: "asc",
        active: true,
        translationKey: "usedBy"
    },
    {
        heading: "Input/Port No.",
        accessor: "inputNumber",
        isNumeric: false,
        id: 3,
        sortByName: "diNo",
        sortDirection: "asc",
        active: true,
        translationKey: "inputOrPortNo"
    }
];

export default DeviceInputColumns;
